<template>
    <b-card-body>
        <b-card-title
            title-tag="h2">
            {{ linkCardTitle }}
        </b-card-title>
        <template v-if="linkItems && linkItems.length > 0">
            <b-list-group
                flush
                class="list-group-multicolor-icons">
                <b-list-group-item
                    v-for="(linkItem, key, index) in linkItems"
                    :key="index"
                    :href="getLinkHref(linkItem)"
                    target="_blank"
                    class="bg-transparent"
                    @click="performClick(linkItem, $event)">
                    <i class="fas fa-square fa-xs"></i>
                    {{ linkItem.linkText }}
                </b-list-group-item>
            </b-list-group>
        </template>
    </b-card-body>
</template>

<script>
import LandingContentBaseComponent from './LandingContentBaseComponent.vue';

// TODO:    Make NewsContentCard and LinksContentCard just one flexible component,
//          since they're effectively doing the same thing.
export default {
    name: 'LinksContentCard',
    extends: LandingContentBaseComponent,
    props: {
        linkCardTitle: {
            type: String,
            required: true,
            default: 'Default Title'
        },
        linkCardBundle: {
            type: String,
            required: true,
            default: 'DefaultContentPath'
        }
    },

    data() {
        return {linkItems: []};
    },

    mounted() {
        // Pull in content from WCM the list of links
        this.initializeContent().then(() => {
            this.setUpLinks();
        });
    },

    methods: {
        setUpLinks: function () {
            const bundle = this.getBundle(this.linkCardBundle);
            const links = [];

            if (bundle) {
                Object.keys(bundle).forEach((key) => {
                    const linkJson = bundle[key];
                    links.push(linkJson);
                });
                // sort by order
                links.sort((a, b) => a.order - b.order);
            }
            this.linkItems = links;
        },
        isInternalLink: function (linkItem) {
            return linkItem.internal;
        },
        getLinkHref: function (linkItem) {
            let href = "#";

            if (!this.isInternalLink(linkItem)) {
                href = linkItem.url;
            }

            return href;
        },
        performClick: function (linkItem, event) {
            if (this.isInternalLink(linkItem)) {
                event.stopPropagation();
                this.routeToName('link', {
                    linkCardTitle: this.linkCardTitle,
                    linkCardBundle: this.linkCardBundle,
                    linkTitle: linkItem.linkText,
                    linkContentItem: linkItem.contentName
                });
            }
        }
    }
};
</script>